/* -----------------UI--------------- */
import { Portal, Snackbar } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

/* -----------------Type declarations--------------- */
type Action = {
	label: string;
	action: () => void;
};

/* -----------------Props--------------- */
type Props = {
	visible: boolean;
	handleDismiss: () => void;
	action?: Action;
	message: string;
	duration?: number;
	usePortal?: boolean;
	onIconPress?: () => void;
	numberOfRows?: "One" | "Two";
};

/* -----------------Component--------------- */
const SnackBarCustom = (props: Props) => {
	const {
		action,
		visible,
		handleDismiss,
		duration = 7000,
		message,
		usePortal = true,
		onIconPress,
		numberOfRows = "One",
	} = props;

	const theme = useAppTheme();
	return (
		<SnackbarHOC usePortal={usePortal}>
			<Snackbar
				visible={visible}
				duration={duration}
				// @ts-ignore
				style={[
					theme.componentOverrides.snackbar,

					{ gap: 10, flexDirection: numberOfRows === "One" ? "row" : "column" },
				]}
				theme={{
					colors: {
						accent: "red",
					},
				}}
				onIconPress={onIconPress}
				onDismiss={handleDismiss}
				action={
					action
						? {
								label: action.label,
								onPress: action.action,
							}
						: undefined
				}
			>
				{message}
			</Snackbar>
		</SnackbarHOC>
	);
};

const SnackbarHOC = ({
	usePortal,
	children,
}: {
	usePortal: boolean;
	children: React.ReactNode;
}) => {
	if (usePortal) {
		return <Portal>{children}</Portal>;
	}
	return <>{children}</>;
};

export default SnackBarCustom;
